export default class DtoQualityIndicatorsResults {
    constructor(obj) {
        this.qualitometer = obj.qualitometer
        this.parameter = obj.parameter
        this.result = obj.result
        this.unit = obj.unit
        this.remark = obj.remark
        this.sampleDate = obj.sampleDate
    }
}